var map = {
	"./": [
		318,
		9
	],
	"./Content": [
		982,
		9,
		0,
		1,
		7,
		8,
		265,
		270
	],
	"./Content/": [
		982,
		9,
		0,
		1,
		7,
		8,
		265,
		270
	],
	"./Content/AllSportsGrid": [
		983,
		9,
		96
	],
	"./Content/AllSportsGrid.js": [
		983,
		9,
		96
	],
	"./Content/Announcement": [
		959,
		9,
		7,
		18
	],
	"./Content/Announcement/": [
		959,
		9,
		7,
		18
	],
	"./Content/Announcement/Announcement.dictionary": [
		902,
		3,
		97
	],
	"./Content/Announcement/Announcement.dictionary.json": [
		902,
		3,
		97
	],
	"./Content/Announcement/Announcement.module.scss": [
		984,
		9,
		271
	],
	"./Content/Announcement/components/AnnouncementItem": [
		1051,
		9,
		98
	],
	"./Content/Announcement/components/AnnouncementItem.tsx": [
		1051,
		9,
		98
	],
	"./Content/Announcement/components/AnnouncementTable": [
		1113,
		9,
		99
	],
	"./Content/Announcement/components/AnnouncementTable.tsx": [
		1113,
		9,
		99
	],
	"./Content/Announcement/components/FilterByTime": [
		1114,
		9,
		100
	],
	"./Content/Announcement/components/FilterByTime.tsx": [
		1114,
		9,
		100
	],
	"./Content/Announcement/get-time-to-fetch-utils": [
		1115,
		9,
		101
	],
	"./Content/Announcement/get-time-to-fetch-utils.ts": [
		1115,
		9,
		101
	],
	"./Content/Announcement/index": [
		959,
		9,
		7,
		18
	],
	"./Content/Announcement/index.tsx": [
		959,
		9,
		7,
		18
	],
	"./Content/Announcement/types": [
		901,
		9,
		102
	],
	"./Content/Announcement/types.ts": [
		901,
		9,
		102
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils": [
		1072,
		9,
		103
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec": [
		1153,
		9,
		104
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec.js": [
		1153,
		9,
		104
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils.ts": [
		1072,
		9,
		103
	],
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils": [
		1050,
		9,
		105
	],
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils.ts": [
		1050,
		9,
		105
	],
	"./Content/MatchCenter": [
		903,
		9,
		19
	],
	"./Content/MatchCenter/": [
		903,
		9,
		19
	],
	"./Content/MatchCenter/MatchCenter.module.scss": [
		985,
		9,
		272
	],
	"./Content/MatchCenter/index": [
		903,
		9,
		19
	],
	"./Content/MatchCenter/index.tsx": [
		903,
		9,
		19
	],
	"./Content/SportGrid": [
		904,
		9,
		20
	],
	"./Content/SportGrid/": [
		904,
		9,
		20
	],
	"./Content/SportGrid/SportGrid.module.scss": [
		986,
		9,
		273
	],
	"./Content/SportGrid/TournamentTable": [
		936,
		9,
		106
	],
	"./Content/SportGrid/TournamentTable.js": [
		936,
		9,
		106
	],
	"./Content/SportGrid/index": [
		904,
		9,
		20
	],
	"./Content/SportGrid/index.jsx": [
		904,
		9,
		20
	],
	"./Content/StageGrid": [
		905,
		9,
		21
	],
	"./Content/StageGrid/": [
		905,
		9,
		21
	],
	"./Content/StageGrid/StageGrid": [
		883,
		9,
		107
	],
	"./Content/StageGrid/StageGrid.module.scss": [
		937,
		9,
		274
	],
	"./Content/StageGrid/StageGrid.tsx": [
		883,
		9,
		107
	],
	"./Content/StageGrid/index": [
		905,
		9,
		21
	],
	"./Content/StageGrid/index.ts": [
		905,
		9,
		21
	],
	"./Content/StreamGrid": [
		906,
		9,
		22
	],
	"./Content/StreamGrid/": [
		906,
		9,
		22
	],
	"./Content/StreamGrid/index": [
		906,
		9,
		22
	],
	"./Content/StreamGrid/index.ts": [
		906,
		9,
		22
	],
	"./Content/components/GridHeader": [
		861,
		9,
		108
	],
	"./Content/components/GridHeader.tsx": [
		861,
		9,
		108
	],
	"./Content/components/SportsGrid": [
		870,
		9,
		109
	],
	"./Content/components/SportsGrid.module.scss": [
		900,
		9,
		275
	],
	"./Content/components/SportsGrid.tsx": [
		870,
		9,
		109
	],
	"./Content/components/TournamentTable": [
		882,
		9,
		110
	],
	"./Content/components/TournamentTable.js": [
		882,
		9,
		110
	],
	"./Content/index": [
		982,
		9,
		7,
		112
	],
	"./Content/index.tsx": [
		982,
		9,
		7,
		112
	],
	"./Live": [
		1154,
		9,
		7,
		135
	],
	"./Live.dictionary": [
		342,
		3
	],
	"./Live.dictionary.json": [
		342,
		3
	],
	"./Live.explanation": [
		1155,
		9,
		136
	],
	"./Live.explanation.ts": [
		1155,
		9,
		136
	],
	"./Live.tsx": [
		1154,
		9,
		7,
		135
	],
	"./LiveDeferred": [
		373,
		9
	],
	"./LiveDeferred.tsx": [
		373,
		9
	],
	"./actions": [
		126,
		9
	],
	"./actions/": [
		126,
		9
	],
	"./actions/index": [
		126,
		9
	],
	"./actions/index.js": [
		126,
		9
	],
	"./actions/liveHub": [
		115,
		9
	],
	"./actions/liveHub.ts": [
		115,
		9
	],
	"./constants": [
		561,
		9,
		256
	],
	"./constants.ts": [
		561,
		9,
		256
	],
	"./index": [
		318,
		9
	],
	"./index.tsx": [
		318,
		9
	],
	"./reducer": [
		296,
		9
	],
	"./reducer/": [
		296,
		9
	],
	"./reducer/entities": [
		354,
		9
	],
	"./reducer/entities.ts": [
		354,
		9
	],
	"./reducer/index": [
		296,
		9
	],
	"./reducer/index.js": [
		296,
		9
	],
	"./reducer/presentation": [
		355,
		9
	],
	"./reducer/presentation.js": [
		355,
		9
	],
	"./selectors/entities": [
		122,
		9
	],
	"./selectors/entities.ts": [
		122,
		9
	],
	"./selectors/gridPresentation": [
		199,
		9,
		257
	],
	"./selectors/gridPresentation.ts": [
		199,
		9,
		257
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1274;
module.exports = webpackAsyncContext;